exports = module.exports = require("../../../../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".engine-workspacepane{top:48px;left:48px;right:280px;bottom:0;z-index:1;background:var(--color-pane-background,#fff);margin:16px}html.engine-preview-mode .engine-workspacepane{left:0;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./~/_less-loader@2.2.3@less-loader!./lib/engine/ui/panes/workspacepane/index.less
// module id = 266
// module chunks = 0